import { Link } from 'found'
import React from 'react'
import LazyLoad from 'react-lazy-load'

import { msToReadingTime } from '../../utils'

import greyTimeIcon from '../../images/grey_time.svg'

export default function Article({
    small, slug, title, link, caption, readingTime,
    author, category, city, picture, hideGroupName
}) {

    hideGroupName = hideGroupName === undefined ? false : hideGroupName
    const group = city || category 
    const className = small ? 'column-49 w-col w-col-3' : 'column-35 w-col w-col-4'
    
    return (
        <div className={className}>
            {link && <Link to={link} className="link-block-9 w-inline-block" />}
            <LazyLoad offsetVertical={100} debounce={false}>
                <img alt="" src={picture} className="image-headline primary" />
            </LazyLoad>
            <div style={{ background: (group && group.color) }} className="_10-copy" />
            <h3 className="heading-9 healines_main">
                <span
                    style={{ textTransform: 'uppercase', color: (group && group.color) }}
                    className="span2 reykjavik"
                >
                    {group && !hideGroupName && group.name}
                </span>{group && !hideGroupName && <span>&nbsp;</span> }
               {title}
            </h3>
            <p className="paragraph-3">{caption}</p>
            <div className="div-block-15">
                <div className="grey">{author.firstname} {author.lastname}</div>
                <LazyLoad offsetVertical={100} debounce={false}>
                    <img alt="" src={greyTimeIcon} width={13} height={13} className="image-24" />
                </LazyLoad>
                <div className="grey2">{msToReadingTime(readingTime)}</div>
            </div>
        </div>
    )
}
